(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wlm-voir-plus');
    if (!btn) return;
    e.preventDefault();
    var sectionId = btn.dataset.section;
    var more = document.getElementById('wlm-desc-more-' + sectionId);
    if (!more) return;
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    more.hidden = expanded;
    btn.setAttribute('aria-expanded', String(!expanded));
    btn.textContent = expanded ? 'Voir plus' : 'Voir moins';
  });
})();